var _rect, _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgGoogledocs = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.382324,
    width: 23.7949,
    height: 24.2355,
    rx: 6.60969,
    fill: "#2ABF86",
    fillOpacity: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9983 6.99219H8.59185C7.98596 6.99219 7.49023 7.48791 7.49023 8.0938V16.9067C7.49023 17.5126 7.98596 18.0083 8.59185 18.0083H15.2015C15.8074 18.0083 16.3031 17.5126 16.3031 16.9067V10.297L12.9983 6.99219ZM12.4475 16.3559H9.69346V15.2543H12.4475V16.3559ZM14.0999 14.7035H9.69346V13.6019H14.0999V14.7035ZM14.0999 13.0511H9.69346V11.9495H14.0999V13.0511ZM12.4475 10.8478V7.8184L15.4769 10.8478H12.4475Z",
    fill: "#16B484"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGoogledocs, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Googledocs.275d1c79.svg";
export { ForwardRef as ReactComponent };